import NavigationHistoryContext, { NavigationEntry } from '@/contexts/navigation-history-context';
import { useEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router-dom';

const MAX_HISTORY_SIZE = 50;

export const NavigationHistoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const historyRef = useRef<NavigationEntry[]>([]);

  useEffect(() => {
    const current = location.pathname + location.search;
    const last = historyRef.current[historyRef.current.length - 1];

    if (current !== last?.path) {
      historyRef.current.push({
        path: current,
        isReplace: navigationType === NavigationType.Replace
      });
    }

    if (historyRef.current.length > MAX_HISTORY_SIZE) {
      historyRef.current = historyRef.current.slice(-MAX_HISTORY_SIZE);
    }
  }, [location, navigationType]);

  return <NavigationHistoryContext.Provider value={historyRef.current}>{children}</NavigationHistoryContext.Provider>;
};
